/* eslint-disable*/
import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { fetchSubclientAlerta, fetchAlertaCategories } from "../../services/alertasServices";
import useFetcher from "../../hooks/useFetcher";
import ModalDeleteAlert from "./modalDeleteAlert";
import DataTable from "react-data-table-component";
import { BlurSpinner } from "../BlurSpinner";
import { CheckSquare, Square, Bell, Trash2 } from "react-feather";
import { Button, FormGroup } from "reactstrap";
import ModalCrearEditarAlerta from "./crearEditarAlertaModal";
import moment from "moment";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import modulos from "../../mocks/modulos";
import { eliminarAlerta } from "../../services/alertasServices";
import { grey } from "@mui/material/colors";
const ModalAlertas = ({ toggle, subclientId, subclienteUtil }) => {
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.CLIENTES);
  const isAudit = currentUser && currentUser.haveAuditAccess(modulos.CLIENTES);
  const [modalDeleteAlerta, setModalDeleteAlerta] = useState(false);
  const [alerta, setAlerta] = useState();
  const [modalNewAlerta, setModalNewAlerta] = useState(false);
  const [alertas, isLoadingAlertas, errorLoadingAlertas, setAlertas, refreshAlertas] = useFetcher(fetchSubclientAlerta, [subclientId]);
  useEffect(async () => {
    refreshAlertas();
  }, [modalNewAlerta]);
  const crearAlerta = () => {
    setAlerta({});
    setModalNewAlerta(true);
    refreshAlertas();
  };

  const editarAlerta = (data) => {
    if (isAudit) return;
    setAlerta(data);
    setModalNewAlerta(true);
    refreshAlertas();
  };
  const handleDelete = async (data) => {
    setModalDeleteAlerta(false);
    const alertaEliminada = await eliminarAlerta(alerta.id);
    refreshAlertas();
    alertaEliminada.message ? toast.success("Alerta Eliminada") : toast.success("Ocurrio un error al eliminar la alerta");
  };

  const isOwner = useMemo(() => subclienteUtil.isOwner(currentUser.user), [subclienteUtil, currentUser.user]);
  return (
    <>
      {modalNewAlerta ? (
        <ModalCrearEditarAlerta toggle={() => setModalNewAlerta(!modalNewAlerta)} alertaInfo={alerta} subclientId={subclientId} readonly={!isAdmin && !isOwner} />
      ) : null}
      {modalDeleteAlerta ? <ModalDeleteAlert toggle={() => setModalDeleteAlerta(!modalDeleteAlerta)} handleDeleteAlerta={handleDelete}></ModalDeleteAlert> : null}
      <Modal className="modal-lg" centered isOpen toggle={toggle}>
        <BlurSpinner isLoading={isLoadingAlertas || isLoading}>
          <div className="w-100 m-0 pr-3 pl-3 pt-4 d-flex  justify-content-end align-items-center ">
            {(isAdmin || isOwner) && !isAudit && <Button onClick={() => crearAlerta()}>Nueva Alerta</Button>}
          </div>

          <ModalBody>
            <DataTable
              className="table-alertas"
              onRowClicked={(row) => {
                editarAlerta(row);
              }}
              columns={[
                {
                  name: "Tipo",
                  selector: (row) => row.tipo.text || "-",
                  sortable: true,
                  center: true,
                  id: "tipo",
                  style: {
                    cursor: "pointer",
                    textAlign: "center",
                    borderRight: "1px solid #e5e5e5",
                  },
                },
                {
                  name: "Concepto",
                  selector: (row) => row.concepto.text || "-",
                  sortable: true,
                  center: true,
                  id: "concepto",
                  style: {
                    cursor: "pointer",
                    textAlign: "center",
                    borderRight: "1px solid #e5e5e5",
                  },
                },
                {
                  name: "Entrega",
                  selector: (row) => {
                    if (row.entrega) {
                      return row.entrega;
                    } else if (row.dueDate) {
                      return moment(row.dueDate).format("DD-MM-YYYY");
                    } else {
                      return "-";
                    }
                  },
                  sortable: true,
                  center: true,
                  id: "entrega",
                  style: {
                    cursor: "pointer",
                    borderRight: "1px solid #e5e5e5",
                  },
                },
                {
                  name: "Frecuencia",
                  selector: (row) => {
                    if (row.entrega) {
                      return "Mensual";
                    } else if (row.dueDate) {
                      return "Única";
                    } else {
                      return "-";
                    }
                  },
                  sortable: false,
                  center: true,
                  id: "frecuencia",
                  style: {
                    cursor: "pointer",
                    textAlign: "center",
                  },
                },
                {
                  name: "",
                  cell: (row) => {
                    const [isHovered, setIsHovered] = React.useState(false);
                    const showTrash = isAdmin || currentUser.user.Pi.itemId == row.responsableId;
                    return showTrash && !isAudit ? (
                      <Trash2
                        onClick={(e) => {
                          if (isAudit) return;
                          setModalDeleteAlerta(!modalDeleteAlerta);
                          setAlerta(row);
                        }}
                        style={{
                          cursor: "pointer",
                          textAlign: "center",
                          color: isHovered ? "red" : "", // Color rojo cuando está en hover
                        }}
                        onMouseEnter={() => setIsHovered(true)} // Establece el estado como hover
                        onMouseLeave={() => setIsHovered(false)} // Restablece el estado cuando se deja de hacer hover
                      />
                    ) : (
                      <Trash2
                        style={{
                          cursor: "pointer",
                          textAlign: "center",
                          color: "#bdbdbd", // Color rojo cuando está en hover
                        }}
                        onMouseEnter={() => setIsHovered(true)} // Establece el estado como hover
                        onMouseLeave={() => setIsHovered(false)} // Restablece el estado cuando se deja de hacer hover
                      />
                    );
                  },
                  id: "alert",
                  sortable: false,
                  center: true,
                  style: {
                    cursor: "pointer",
                    textAlign: "center",
                    onHover: "#e35205",
                  },

                  width: "40px",
                  compact: true,
                },
              ]}
              data={alertas !== [] && alertas !== undefined ? alertas.rows : []}
              noDataComponent={<div className="p-3">No hay Alertas</div>}
              responsive
              striped
              hover
            />
          </ModalBody>
        </BlurSpinner>
      </Modal>
    </>
  );
};

export default ModalAlertas;
